(function() {
  function initAudioSection(section) {
    if (!section || section.dataset.slAudioInitialized === 'true') return;
    section.dataset.slAudioInitialized = 'true';

    function formatDuration(seconds) {
      if (!seconds || !isFinite(seconds)) {
        return '';
      }

      var rounded = Math.round(seconds);
      var minutes = Math.floor(rounded / 60);
      var rest = rounded % 60;

      if (minutes > 0 && rest > 0) {
        return minutes + ' Min. ' + rest + ' Sek.';
      }

      if (minutes > 0) {
        return minutes + ' Min.';
      }

      return rest + ' Sek.';
    }

    function updateDuration(player) {
      var index = player.getAttribute('data-sl-audio-player');
      var duration = formatDuration(player.duration);
      var cardTarget = section.querySelector('[data-sl-audio-duration="' + index + '"]');
      var metaTarget = section.querySelector('[data-sl-audio-meta-duration="' + index + '"]');

      if (!duration) {
        if (cardTarget) {
          cardTarget.textContent = '';
        }
        if (metaTarget) {
          metaTarget.textContent = '';
        }
        return;
      }

      if (cardTarget) {
        cardTarget.textContent = duration;
      }

      if (metaTarget) {
        metaTarget.textContent = ' – ' + duration;
      }
    }

    function initAudioDurations() {
      var players = section.querySelectorAll('[data-sl-audio-player]');

      players.forEach(function(player) {
        if (player.readyState >= 1) {
          updateDuration(player);
        }

        player.addEventListener('loadedmetadata', function() {
          updateDuration(player);
        });

        player.addEventListener('durationchange', function() {
          updateDuration(player);
        });
      });
    }


    initAudioDurations();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-sl-audio-sample-section]').forEach(initAudioSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
